import React from "react";
import "./Cms.css";

const Faqs = () => {
  return (
    <div className="mt-4 mb-5 marginContainer">
      <h1 className="mb-5 page-title">Frequently Asked Questions (FAQs)</h1>

      <section className="section">
        <h2 className="section-title">General Questions</h2>
        <div className="faq-item">
          <h3 className="faq-question">What is Easy QIST?</h3>
          <p className="faq-answer">
            Easy QIST is a digital platform offering easy installment plans for
            purchasing electronics, mobiles, bikes, home appliances, and
            furniture in Pakistan. We provide hassle-free applications,
            competitive rates, fast approvals, and free delivery without
            requiring a credit card or heavy advance.
          </p>
        </div>

        <div className="faq-item">
          <h3 className="faq-question">
            Who can apply for an installment plan with Easy QIST?
          </h3>
          <p className="faq-answer">
            Applicants must be Pakistani residents aged 18 or above, with a
            valid CNIC and steady income source. Salaried employees,
            freelancers, and business owners are eligible. No credit history or
            bank account is mandatory.
          </p>
        </div>

        <div className="faq-item">
          <h3 className="faq-question">
            How long does approval for an installment plan take?
          </h3>
          <p className="faq-answer">
            Most applications are reviewed and approved within minutes to 24
            hours. Upon approval, products are delivered within 2-3 business
            days.
          </p>
        </div>
      </section>

      <section className="section">
        <h2 className="section-title">Application Process</h2>
        <div className="faq-item">
          <h3 className="faq-question">
            What documents are required for application?
          </h3>
          <p className="faq-answer">
            You'll need: CNIC copy, recent salary slip or income proof, and 2
            references. No lengthy paperwork – upload them securely via the app
            or website during the simple online process.
          </p>
        </div>

        <div className="faq-item">
          <h3 className="faq-question">
            Can I apply for multiple installment plans?
          </h3>
          <p className="faq-answer">
            Yes, but only one active application per user at a time. Previous
            purchases must be settled or resolved before new ones.
          </p>
        </div>

        <div className="faq-item">
          <h3 className="faq-question">What if my application is rejected?</h3>
          <p className="faq-answer">
            We'll provide reasons via email or app notification. You can reapply
            after addressing issues, typically after 30 days. No processing fees
            for rejections.
          </p>
        </div>
      </section>

      <section className="section">
        <h2 className="section-title">Installment Terms and Payments</h2>
        <div className="faq-item">
          <h3 className="faq-question">
            What products and installment options are available?
          </h3>
          <p className="faq-answer">
            Shop mobiles, bikes, refrigerators, TVs, furniture, and more from
            top brands. Installments range from 3-24 months with low monthly
            payments starting from PKR 1,000, based on product price and your
            profile.
          </p>
        </div>

        <div className="faq-item">
          <h3 className="faq-question">How do I make installment payments?</h3>
          <p className="faq-answer">
            Pay via auto-debit from your bank account, online transfer,
            EasyPaisa, JazzCash, or cash at designated points. Set up reminders
            in the app to avoid late fees.
          </p>
        </div>

        <div className="faq-item">
          <h3 className="faq-question">
            What happens if I miss an installment payment?
          </h3>
          <p className="faq-answer">
            A late fee of up to 5% applies after the grace period (usually 5-7
            days). Contact us for extensions in case of financial hardship; we
            offer flexible rescheduling up to 2 times per purchase.
          </p>
        </div>
      </section>

      <section className="section">
        <h2 className="section-title">Security and Support</h2>
        <div className="faq-item">
          <h3 className="faq-question">
            Is my data and purchase secure with Easy QIST?
          </h3>
          <p className="faq-answer">
            Yes, we use SSL encryption, comply with SBP and PDPA regulations in
            Pakistan, and ensure 100% original products. We never share data
            without consent. Review our Privacy Policy for details.
          </p>
        </div>

        <div className="faq-item">
          <h3 className="faq-question">How can I contact support?</h3>
          <p className="faq-answer">
            Email support@easyqist.com, call +92-300-1234567 (9 AM - 6 PM PKT),
            or use in-app chat. Response time: 2 hours for urgent queries.
          </p>
        </div>
      </section>

      <p className="cmsDetails paragraph mt-4">
        Still have questions? Reach out to our team – we're here to help!
      </p>
    </div>
  );
};

export default Faqs;
